import { Slider } from '@heroui/react';

interface RangeSliderProps {
  value: number;
  min: number;
  max: number;
  step?: number;
  onChange: (value: number) => void;
  /** Accessible label (no visible label is rendered — callers supply their own). */
  ariaLabel: string;
  className?: string;
}

/**
 * Horizontal slider — HeroUI v3 Slider with its NATIVE styling. We render
 * Track/Fill/Thumb without custom classes so the control looks exactly like
 * the HeroUI docs (rounded track, accent fill, large pill thumb) instead of
 * the previously hand-tuned thinner variant. The legacy native-range
 * fallback was dropped when the app went HeroUI-only.
 */
export function RangeSlider(props: RangeSliderProps) {
  return (
    <Slider
      aria-label={props.ariaLabel}
      minValue={props.min}
      maxValue={props.max}
      step={props.step ?? 1}
      value={props.value}
      onChange={(v) => props.onChange(Array.isArray(v) ? (v[0] ?? 0) : v)}
      className={props.className ?? 'w-full'}
    >
      <Slider.Track>
        <Slider.Fill />
        <Slider.Thumb />
      </Slider.Track>
    </Slider>
  );
}
